// extracted by mini-css-extract-plugin
module.exports = {"Radio":"Radio_Radio__25Rvm","--correct":"Radio_--correct__29LZx","--incorrect":"Radio_--incorrect__3HPyr","--showAnswer":"Radio_--showAnswer__2BgFc","fadein":"Radio_fadein__2e5gF"};